import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { noop } from 'lodash';
import React from 'react';
import { useQuery } from 'react-query';
import { getConversionRuleListByCriteria, GetProductConversionRuleCriteriaParams, ProductConversionRuleResponse } from 'services/parametersService';


export type ProductConversionRuleListSelectProps = SelectProps<any> &{
  params: GetProductConversionRuleCriteriaParams;
  value?:   ProductConversionRuleResponse;
  onChange?: (data?:ProductConversionRuleResponse) => void;
  onSelected?: (data: ProductConversionRuleResponse) => void;

  disabled?: boolean;
  allowClear?:boolean;
  style?: any;
  multiMode?:boolean
};

const ProductConversionRuleListSelect = ({
  params,
  value,
  onChange = noop,
  onSelected,
  multiMode,
  ...otherProps
}:ProductConversionRuleListSelectProps) => {
  const { data: data,isLoading } = useQuery(
    ['getConversionRuleListByCriteria', params],
    () => getConversionRuleListByCriteria(params).then((res) => res.list || []),
  );

  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value);
    if (onSelected) {
      onSelected(data?.find((item) => item.targetPrcode === value)!);
    }
  };
  return (
    multiMode?
    <Select onChange={handleChange} value={value} {...otherProps} loading={isLoading} allowClear mode="multiple">
      {data?.map((data) => (
        <Select.Option value={data.targetPrcode} key={data.targetPrcode}>
          {data.targetPrcodelabel}
        </Select.Option>
      ))}
    </Select>:
    <Select onChange={handleChange} value={value} {...otherProps} loading={isLoading} allowClear>
      {data?.map((data) => (
        <Select.Option value={data.targetPrcode} key={data.targetPrcode}>
          {data.targetPrcodelabel}
        </Select.Option>
      ))}
    </Select>
  );
};

export default ProductConversionRuleListSelect;
